package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class AccountQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> getAllAccounts(mapper: (
    id: String,
    name: String,
    logoEmoji: String?,
    logoUri: String?,
    isVisible: Boolean,
    isHidden: Boolean,
    isSavings: Boolean,
    isArchived: Boolean,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(-953_037_819, arrayOf("AccountEntity"), driver, "Account.sq",
      "getAllAccounts",
      "SELECT AccountEntity.id, AccountEntity.name, AccountEntity.logoEmoji, AccountEntity.logoUri, AccountEntity.isVisible, AccountEntity.isHidden, AccountEntity.isSavings, AccountEntity.isArchived, AccountEntity.isDeleted, AccountEntity.createdAtEpochMs, AccountEntity.updatedAtEpochMs FROM AccountEntity") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getBoolean(4)!!,
      cursor.getBoolean(5)!!,
      cursor.getBoolean(6)!!,
      cursor.getBoolean(7)!!,
      cursor.getBoolean(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!
    )
  }

  public fun getAllAccounts(): Query<AccountEntity> = getAllAccounts { id, name, logoEmoji, logoUri,
      isVisible, isHidden, isSavings, isArchived, isDeleted, createdAtEpochMs, updatedAtEpochMs ->
    AccountEntity(
      id,
      name,
      logoEmoji,
      logoUri,
      isVisible,
      isHidden,
      isSavings,
      isArchived,
      isDeleted,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public suspend fun upsert(
    id: String,
    name: String,
    logoEmoji: String?,
    logoUri: String?,
    isVisible: Boolean,
    isHidden: Boolean,
    isSavings: Boolean,
    isArchived: Boolean,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) {
    driver.execute(281_545_155, """
        |INSERT OR REPLACE INTO AccountEntity(id, name, logoEmoji, logoUri, isVisible, isHidden, isSavings, isArchived, isDeleted, createdAtEpochMs, updatedAtEpochMs)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 11) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, logoEmoji)
          bindString(3, logoUri)
          bindBoolean(4, isVisible)
          bindBoolean(5, isHidden)
          bindBoolean(6, isSavings)
          bindBoolean(7, isArchived)
          bindBoolean(8, isDeleted)
          bindLong(9, createdAtEpochMs)
          bindLong(10, updatedAtEpochMs)
        }.await()
    notifyQueries(281_545_155) { emit ->
      emit("AccountEntity")
    }
  }

  public suspend fun deleteById(id: String) {
    driver.execute(-1_978_397_007, """DELETE FROM AccountEntity WHERE id = ?""", 1) {
          bindString(0, id)
        }.await()
    notifyQueries(-1_978_397_007) { emit ->
      emit("AccountEntity")
    }
  }
}
